import { BoldText } from '@elements/Common';
import { InfoIcon } from '@phosphor-icons/react';
import { CommonUtility } from '@utility/common';
import { LightPopup } from '@elements/Popup';
import { ImageWithFallback } from '@components/FallbackImage';

const ROW = 'sk:grid sk:grid-cols-[1fr_6rem] sk:items-center sk:gap-2';

function ItemBox({ item }) {
  return (
    <div className="sk:flex sk:w-[min(400px,calc(100vw-2rem))] sk:flex-col sk:gap-2 sk:text-xs sk:text-fg">
      <div className={ROW}>
        <BoldText>Combined MOQ</BoldText>
        <span className="sk:text-center sk:text-fg-tertiary">Sub-MOQ</span>
      </div>
      <div className="sk:flex sk:max-h-62.5 sk:flex-col sk:gap-2 sk:overflow-y-auto">
        {(item.items || []).map(subItem => (
          <div key={subItem.item_id} className={ROW}>
            <div className="sk:flex sk:min-w-0 sk:items-center sk:gap-2">
              <ImageWithFallback
                src={subItem.p_images?.display_image}
                alt={subItem.p_title}
                className="sk:size-8 sk:shrink-0 sk:rounded-md sk:border sk:border-solid sk:border-border-subtle sk:object-contain"
              />
              <div className="sk:min-w-0">
                <div className="sk:truncate">{subItem.p_title}</div>
                <BoldText>{subItem.p_sku}</BoldText>
              </div>
            </div>
            <div className="sk:text-center">
              {CommonUtility.numberWithCommas(subItem.moq)} Units
            </div>
          </div>
        ))}
      </div>
      <div
        className={`${ROW} sk:border-0 sk:border-t sk:border-solid sk:border-rule sk:pt-3`}
      >
        <BoldText>Collective MOQ</BoldText>
        <div className="sk:text-center">
          {CommonUtility.numberWithCommas(item.collective_moq)} Units
        </div>
      </div>
    </div>
  );
}

export function GroupedMOQPopup({ data }) {
  return (
    <LightPopup
      trigger={
        <InfoIcon
          className="sk:ml-1 sk:cursor-pointer sk:text-fg-tertiary"
          aria-label="Combined MOQ"
        />
      }
      contentMaxHight="none"
    >
      <ItemBox item={data} />
    </LightPopup>
  );
}
